import { Text } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';
export const Copyright = () => (
  <Text textStyle="p" color="blackAlpha.400">
    {'© ' + dayjs().year() + ' SpotOn Transact, LLC.'}
  </Text>
);
